document.addEventListener('DOMContentLoaded', function () {
    const formatOption = document.querySelector('[data-option="Format"] select'); // Ajustez ce sélecteur selon votre thème

    if (formatOption) {
        formatOption.addEventListener('change', function () {
            const selectedValue = formatOption.value;
            const targetElement = document.querySelector('.tcustomizer-photo-uploaded'); // L'élément à modifier

            if (targetElement) {
                // Réinitialisez toutes les classes
                targetElement.classList.remove('format-portrait');

                // Si le format Portrait est sélectionné, appliquez la classe "format-portrait"
                if (selectedValue === 'Portrait') {
                    targetElement.classList.add('format-portrait');
                }
            }
        });

        // Déclenche un événement de changement initial pour appliquer la classe au chargement
        formatOption.dispatchEvent(new Event('change'));
    }
});
